import type { CurrentBalanceDTO } from "../models/currentBalanceDto";
import type { CurrentBalanceEntity } from "../../domain/entities/CurrentBalanceEntity";

export function currentBalanceDtoToEntity(dto: CurrentBalanceDTO): CurrentBalanceEntity {
  return {
    asOfLabel: dto.asOfLabel,
    balanceAmount: dto.balanceAmount,
    balanceAmountRaw: dto.balanceAmountRaw,
    balanceSubtitle: dto.balanceSubtitle,
    booksClosedThrough: dto.books_closed_through ?? null,
    chart: {
      labels: dto.chart?.labels ?? [],
      values: dto.chart?.values ?? [],
    },
    momPercent: dto.momPercent ?? null,
    runwayMonths: dto.runwayMonths ?? null,
    runwayStatus: dto.runwayStatus ?? null,
  };
}

